import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { AttendanceService, Channel, ChannelService, ConfirmationComponent, Contact, ContactEditComponent, ContactGroup, ContactGroupService, ContactService, CustomFieldContact, CustomFieldService, DepartmentService, LeadSource, LeadSourceService, Note, NoteService, Pager, Tag, TagService, TeamService, TypeFieldEnum } from 'lib-trend-core';
import { debounceTime, distinctUntilChanged, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { ContactViewNoteEditComponent } from './contact-view-note-edit/contact-view-note-edit.component';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'contact-view-component',
    templateUrl: './contact-view.v2.component.html',
    // templateUrl: './contact-view.component.html',
    styleUrl: 'contact-view.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactViewComponent extends ContactEditComponent implements OnInit {
  filterControlChannel: FormControl = new FormControl('');
  filterControlLeadSource: FormControl = new FormControl('');

  listLeadSource: Array<LeadSource> = new Array<LeadSource>();
  listChannel: Array<Channel> = new Array<Channel>();
  leadSourceSelected: LeadSource = {} as LeadSource;

  override contact: Contact;
  disabledCustomInput: boolean = true;
  navType: 'notes' | 'tags' | 'attendances' | 'customFields' | 'group' | 'leadSource' | 'portfolio' = 'notes';
  contactDetails: any;
  tags: Array<Tag> = new Array<Tag>();
  showSelectTags: boolean = true;
  isLeadSourceSelected: boolean = false;

  fields: Array<{ id: number; name: string; value: string }> = [];
  pager: Pager<Note> = new Pager<Note>({ perPage: 10 });
  listObservable: Observable<Pager<Note>>;
  private termoDaBusca: Subject<string> = new Subject<string>();

  customFieldsView: Array<CustomFieldContact> = [];
  originalGroups: ContactGroup[] = [];
  fieldOptions: string[] = [];

  allCustomFields: any[] = [];
  isEditMode = false;
  editedContact: Contact = {} as Contact;
  constructor(
    injector: Injector,
    public attendanceService: AttendanceService,
    public noteService: NoteService,
    public customFieldService: CustomFieldService,
    public dialog: MatDialog,
    public contactGroupService: ContactGroupService,
    dialogRef: MatDialogRef<ContactViewComponent>,
    contactService: ContactService,
    contactGrupoService: ContactGroupService,
    departmentService: DepartmentService,
    tagService: TagService,
    teamService: TeamService,
    fieldsCustomService: CustomFieldService,
    public channelService: ChannelService,
    public leadSourceService: LeadSourceService,
    @Inject(MAT_DIALOG_DATA) override data: Contact,

  ) {
    super(
      injector,
      dialogRef,
      contactService,
      contactGrupoService,
      departmentService,
      tagService,
      teamService,
      fieldsCustomService,
      data
    );
  }

  override ngOnInit() {
    this.createForm();
    this.loadCustomFields();
    this.loadFieldOptions();
    this.getListLeadSource();
    const idContact = super.getParam('id');
    if (!!idContact) {
      this.loadContactDetails(idContact);
    }
    this.tagService.getList().subscribe(tag => this.tags = tag);
    this.getPagerNote();
    this.loadGroups();
  }

  protected override createForm(): void {
    this.formGroup = this.formBuilder.group({
      attendant: [null],
      department: [null],
      leadSource: [null],
    });
  }

  setupObservableSearch() {
    this.listObservable = this.termoDaBusca
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .pipe(switchMap(term => {
        return this.noteService.getAll(this.pager.page, this.pager.perPage, term, this.searchParams);
      }));
    this.listObservable.subscribe((pager: Pager<Note>) => {
      this.pager = pager;
    });
  }

  getPagerNote(): void {
    this.loadingContent = true;

    const idContact = super.getParam('id');
    if (!!idContact) {
      this.searchParams = { contact: idContact };
    }

    this.noteService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams).subscribe({
      next: (pager: Pager<Note>) => {
        this.pager = pager;
        this.setupObservableSearch();
        this.loadingContent = false;
      },
    });
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getPagerNote();
  }

  delete(item: Contact): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.contactService.delete(item._id).subscribe({
          next: () => {
            this.router.navigate(['/contact']);
            this.alertService.success(this.t('contact.view.contactDeletedSuccess'));
          },
          error: err => this.alertService.error(err.error.message)
        })
      }
    });
  }

  loadContactDetails(contactId: string) {
    this.contactService.getContactDetailsWithCounts(contactId).subscribe({
      next: (details: any[]) => {
        if (details && details.length > 0) {
          this.contactService.getById(contactId).subscribe({
            next: (contact: Contact) => {
              this.contact = contact;
              this.editedContact = { ...contact };
              this.customFieldsView = contact.customFields || [];
              this.contactDetails = details;
              this.formGroup.get('attendant').setValue(this.editedContact.customerPortfolio?.user);
              this.formGroup.get('department').setValue(this.editedContact.customerPortfolio?.department);
              if (this.editedContact.customerPortfolio?.department) {
                this.loadAttendant();
              }
            },
            error: (err) => this.alertService.error(err.error.message)
          });
        }
      },
      error: (err) => this.alertService.error(err.error.message)
    });
  }
  getGenderDisplay(gender: string): string {
    const genderMap = {
      'MALE': 'contact.gender.male',
      'FEMALE': 'contact.gender.female',
      'OTHER': 'contact.gender.other',
    };
    return this.t(genderMap[gender] || gender);
  }

  formatTin(tin: string): string {
    if (!tin) return '-';
    return tin.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  getGroupsDisplay(groups: any[]): string {
    if (!groups || groups.length === 0) return '-';
    return groups.map(group => group.name || group).join(', ');
  }

  getTagsDisplay(tags: any[]): string {
    if (!tags || tags.length === 0) return '-';
    return tags.map(tag => tag.title || tag).join(', ');
  }

  loadCustomFields() {
    this.customFieldService.getList().subscribe(fields => {
      this.fieldOptions = fields.map(field => field.name);
      this.allCustomFields = fields;
    });
  }

  loadFieldOptions() {
    this.customFieldService.getList().subscribe(fields => {
      this.fieldOptions = fields.map(field => field.name);
    });
  }

  //GETTERS

  get notes(): any[] {
    if (!this.contactDetails?.[0]?.notes) {
      return [];
    }
    return this.contactDetails[0].notes;
  }

  get contactTags(): any[] {
    if (!this.contactDetails?.[0]?.tags) {
      return [];
    }
    return this.contactDetails[0].tags;
  }

  get totalNotes(): number {
    return this.contactDetails?.[0]?.totalNotes || 0;
  }

  get totalTags(): number {
    return this.contactDetails?.[0]?.totalTags || 0;
  }

  get countAttendance(): number {
    return this.contactDetails?.[0]?.countAttendance || 0;
  }

  get availableTags(): Tag[] {
    return this.tags ?? [];
  }

  get selectedTags(): Tag[] {
    return this.contactDetails?.[0]?.tags || [];
  }

  trackByTagId(index: number, tag: Tag): string {
    return tag._id;
  }

  changeNavType(type: typeof this.navType) {
    this.navType = type;
  }

  removeTag(tagToRemove: Tag) {
    if (this.contact && this.contact.tags) {
      // Derive the new list from what is actually RENDERED (`selectedTags`, which comes
      // from the aggregation and excludes soft-deleted tags), not from `this.contact.tags`
      // (a plain populate that still carries them). Writing the unfiltered array back
      // re-persisted every deleted tag id on each removal, so they could never be removed
      // from this screen — they are not rendered, therefore never filtered out.
      const updatedTags = this.selectedTags.filter(tag => tag._id !== tagToRemove._id);

      // Tag-only write: `updateTags` $sets just `tags`, so the rest of the contact is
      // never overwritten with this screen's snapshot.
      const updatedContact = <Contact>{ _id: this.contact._id, tags: updatedTags };

      this.contactService.updateTags(updatedContact).subscribe({
        next: (response) => {
          this.contact.tags = updatedTags;
          this.alertService.success(this.t('contact.view.tagRemovedSuccess'));
          this.loadContactDetails(this.contact._id);
        },
        error: (err) => {
          this.alertService.error(this.t('contact.view.tagRemoveError'));
          this.loadContactDetails(this.contact._id);
        }
      });
    }
  }

  isTagSelected(tagId: string): boolean {
    return this.contact?.tags?.some(tag => tag._id === tagId) || false;
  }

  selected(event: MatSelectChange): void {
    // The template binds [value]="item._id", so the event carries the id as a string.
    const idTag: string = event.value?._id ?? event.value;

    if (this.contact && !!idTag) {
      const tagExists = this.selectedTags.some(tag => tag._id === idTag);

      if (!tagExists) {
        // Built from the rendered list (see removeTag) so soft-deleted tag ids are not
        // written back along with the new one.
        const updatedTags = [...this.selectedTags, <Tag>{ _id: idTag }];

        this.contactService.updateTags(<Contact>{ _id: this.contact._id, tags: updatedTags }).subscribe({
          next: (updatedContact) => {
            this.alertService.success(this.t('contact.view.tagAddedSuccess'));
            this.loadContactDetails(this.contact._id);
          },
          error: (err) => {
            this.alertService.error(this.t('contact.view.tagAddError'));
          }
        });
      }
    }
    this.showSelectTags = true;
  }
  addField(): void {
    const newField = {
      id: this.fields.length + 1,
      name: '',
      value: '',
    };
    this.fields.push(newField);
  }

  removeField(id: number): void {
    this.fields = this.fields.filter(field => field.id !== id);
  }

  addCustomField() {
    const newFieldName = 'Adicionar Campo';
    const exists = this.customFieldsView.some(field => field.name === newFieldName);
    if (!exists) {
      this.customFieldService.getList().subscribe(fields => {
        const availableField = fields.find(field => !this.customFieldsView.some(cf => cf._id === field._id));
        if (availableField) {
          const newField: CustomFieldContact = {
            _id: availableField._id,
            name: '',
            description: availableField.description || '',
            type: availableField.type || TypeFieldEnum.TEXT,
            value: null
          };
          this.customFieldsView.push(newField);
        } else {
          this.alertService.error(this.t('contact.view.noMoreCustomFieldsAvailable'));
        }
      });
    } else {
      this.alertService.error(this.t('contact.view.customFieldAlreadyExists'));
    }
  }

  removeCustomField(index: number) {
    this.customFieldsView.splice(index, 1);
  }

  isFieldSelected(fieldName: string, currentIndex: number): boolean {
    return this.customFieldsView.some((field, index) =>
      index !== currentIndex && field.name === fieldName
    );
  }

  onCustomFieldChange(index: number, fieldName: string) {
    const field = this.customFieldsView[index];
    if (!fieldName) {
      this.alertService.error(this.t('contact.view.fieldNameRequired'));
      return;
    }

    const selectedField = this.allCustomFields.find(f => f.name === fieldName);
    if (selectedField) {
      field._id = selectedField._id;
      field.name = fieldName;
      field.type = selectedField.type;
      field.description = selectedField.description;
    }
  }

  saveCustomFields() {
    this.loading = true;
    const missingFields = this.customFieldsView.filter(field => !field.name || !field.value);

    if (missingFields.length > 0) {
      this.alertService.warning(this.t('contact.view.fillAllRequiredFields'));
      return;
    }

    // Send only the custom fields, under the field name the schema actually has
    // (`customFields` — `customFieldsView` is this component's local view model and
    // was being dropped server-side). Posting the whole contact would also overwrite
    // tags and every other field with this screen's snapshot.
    const updatedContact = <Contact>{ _id: this.contact._id, customFields: this.customFieldsView };
    this.contactService.update(this.contact._id, updatedContact).subscribe({
      next: () => {
        this.alertService.success(this.t('contact.view.customFieldsSavedSuccess'));
        this.loadContactDetails(this.contact._id);
      },
      error: (err) => {
        this.alertService.error(this.t('contact.view.customFieldsSaveError'));
        this.loading = false;
      },
      complete: () => (this.loading = false)
    });
  }

  getContactStatus(status: string | undefined): string {
    switch (status) {
      case 'VALIDATED':
        return this.t('contact.valid.validated');
      case 'NOT_VALIDATED':
        return this.t('contact.valid.notValidated');
      case 'INVALID':
        return this.t('contact.valid.invalid');
      default:
        return this.t('contact.valid.unknown');
    }
  }

  loadGroups() {
    this.searchParams = {
      company: this.getIDCurrentCompany(),
    };

    this.contactGroupService.getList().subscribe({
      next: (value: Array<ContactGroup>) => {
        this.originalGroups = value;
        this.setupObservableSearch();
      },
      error: (err) => this.alertService.error(err.error.message),
    });
  }

  addGroup(originalGroups: ContactGroup) {
    if (!this.contact.groups.some(group => group._id === originalGroups._id)) {
      this.contact.groups.push(originalGroups);
    } else {
      this.alertService.warning(this.t('contact.view.groupAlreadyAdded'));
    }
  }

  removeGroup(groupToRemove) {
    this.contact.groups = this.contact.groups.filter(group => group !== groupToRemove);
  }

  saveContact(item: Contact) {
    this.loading = true;
    if (!this.editedContact.name) {
      this.alertService.warning(this.t('contact.view.nameFieldRequired'));
      return;
    }

    if (!this.editedContact.phone) {
      this.alertService.warning(this.t('contact.view.phoneFieldRequired'));
      return;
    }

    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    if (this.formGroup.get('attendant').value && this.formGroup.get('department').value) {
      this.editedContact.customerPortfolio = {
        user: this.formGroup.get('attendant').value,
        department: this.formGroup.get('department').value
      }
    } else {
      this.editedContact.customerPortfolio = null;
    }
    this.editedContact.groups = this.contact.groups.map(group => ({ ...group }));

    // This form does not own tags — the screen has a dedicated tag add/remove UI.
    // `editedContact` is a snapshot taken when editing started, so sending its `tags`
    // would revert anything tagged in the meantime.
    delete this.editedContact.tags;

    this.contactService.update(this.contact._id, this.editedContact).subscribe({
      next: () => {
        this.loadContactDetails(this.contact._id);
        this.alertService.success(this.t('contact.view.contactSavedSuccess'));
        this.cancelEdit();
        this.loading = false;
      },
      error: () => (this.loading = false),
      complete: () => (this.loading = false)
    });
  }

  editContact(item: Contact): void {
    this.editedContact = { ...this.contact };
    this.isEditMode = true;
  }

  cancelEdit(): void {
    this.isEditMode = false;
    this.editedContact = { ...this.contact };
  }

  openNoteDialog(note?: Note) {
    const dialogRef = this.dialog.open(ContactViewNoteEditComponent, {
      width: '600px',
      data: {
        note: note,
        contact: this.contact,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadContactDetails(this.contact._id);
        this.getPagerNote()
      }
    });
  }

  removeNote(note: Note): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.noteService.delete(note._id).subscribe({
          next: () => {
            this.alertService.success(this.t('contact.view.noteDeletedSuccess'));
            this.loadContactDetails(this.contact._id);
            this.getPagerNote();
          },
          error: err => this.alertService.error(err.error.message)
        });
      }
    });
  }

  openNewConversation() {
    this.router.navigate(['/attendance/panel'], {
      queryParams: { contactId: this.contact._id }
    });
  }

  openAttendanceNote(attendanceId: string, status: string) {
    if (attendanceId && status) {
      this.router.navigate(['/attendance/panel'], {
        queryParams: {
          id: attendanceId,
          status: status
        }
      });
    }
  }

  private getListLeadSource(): void {
    this.leadSourceService.getList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (leadSources: Array<LeadSource>) => {
          this.listLeadSource = leadSources;
        },
        error: (error) => {
          this.alertService.error(error.error.message);
        }
      });
  }

  onSelectLeadSource(event: MatSelectChange): void {
    const selected: LeadSource = event.value;
    this.isLeadSourceSelected = !!selected;

    if (selected) {
      this.leadSourceSelected = selected;
      this.formGroup.patchValue({ name: selected?.name ?? '' });
    }
  }

  saveLeadSource(leadSource: LeadSource): void {
    this.contactService.updateLeadSource(this.contact._id, leadSource)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contact: Contact) => {
          this.contact = contact;
        },
        error: (error) => {
        },
        complete: () => {
          this.alertService.success(this.t('contact.view.leadSourceSavedSuccess'));
          this.formGroup.reset();
        }
      });
  }

  onStateInput(event: any): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
    this.editedContact.state = input.value;
  }
}
